import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem, RadioGroup, FormControlLabel, Radio, FormLabel, FormControl, CircularProgress, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DataTable from "../components/DataTable";
import SnackbarAlert from "../components/SnackbarAlert";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import CloseIcon from "@mui/icons-material/Close";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Tabs, Tab } from "@mui/material";
import noImage from "../assets/noimage.png";
export default function Products() {
    const [dataSource, setDataSource] = useState([]);
    const [search, setSearch] = useState("");
    const [tab, setTab] = useState(0);
    const [editAttributesData, setEditAttributesData] = useState([]);
    const [preview, setPreview] = useState(null);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);
    const [editState, setEditState] = useState(null);
    const [loading, setLoading] = useState(false);
    const [productCode, setProductCode] = useState();
    const [productCodeExists, setProductCodeExists] = useState(false);
    const [checkingProductCode, setCheckingProductCode] = useState(false);
    const [productName, setProductName] = useState();
    const [productDescription, setProductDescription] = useState();
    const [productImage, setProductImage] = useState("");
    const [sizeGuideImage, setSizeGuideImage] = useState("");
    const [productPreview, setProductPreview] = useState("");
    const [sizeGuidePreview, setSizeGuidePreview] = useState("");
    const [productMainCategory, setProductMainCategory] = useState();
    const [productSubCategory, setProductSubCategory] = useState();
    const [productBrand, setProductBrand] = useState();
    const [productTax, setProductTax] = useState();
    const [mainCategoryData, setMainCategoryData] = useState([]);
    const [subCategoryData, setsubCategoryData] = useState([]);
    const [ageCategoryData, setAgeCategoryData] = useState([]);
    const [sizeCategoryData, setSizeCategoryData] = useState([]);
    const [brandCategoryData, setBrandCategoryData] = useState([]);
    const [selectAgeData, setSelectAgeData] = useState([]);
    const [singleCheckout, setSingleCheckout] = useState(0);
    const [taxData, setTaxData] = useState([]);
    const [colorData, setColorData] = useState([]);
    const [openAttrModal, setOpenAttrModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleteData, setDeleteData] = useState({ id: null, type: null });
    const [editOpen, setEditOpen] = useState(false);
    const [editType, setEditType] = useState("");
    const [editData, setEditData] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const [colorStatus, setColorStatus] = useState('no');
    const [sizeStatus, setSizeStatus] = useState('no');
    const [ageStatus, setAgeStatus] = useState('no');
    const [selectedColorId, setSelectedColorId] = useState(null);
    const [selectedColorImage, setSelectedColorImage] = useState(null);
    const [selectedSizeId, setSelectedSizeId] = useState(null);
    const [mrp, setMrp] = useState("");
    const [price, setPrice] = useState("");
    const [selectedAgeId, setSelectedAgeId] = useState(null);
    const [ageMrp, setAgeMrp] = useState("");
    const [agePrice, setAgePrice] = useState("");
    const [ageretailsQty, setAgeRetailQty] = useState(0);
    const [sizeretailsQty, setSizeRetailQty] = useState(0);
    const [productRfId, setProducRfId] = useState(0);
    const [sizeRows, setSizeRows] = useState([
        { sizeId: "", mrp: "", price: "", qty: "" }
    ]);
    const [ageRows, setAgeRows] = useState([
        { ageId: "", mrp: "", price: "", qty: "" }
    ]);
    useEffect(() => {
        fetchProductdata();
        fetchMasterData();
    }, []);
    const fetchProductdata = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "product/all-products";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchMasterData = async () => {
        setLoading(true);
        const apis = {
            maincategories: setMainCategoryData,
            brand: setBrandCategoryData,
            tax: setTaxData,
            sizes: setSizeCategoryData,
            colors: setColorData,
            ages: setAgeCategoryData
        };
        try {
            const keys = Object.keys(apis);
            const responses = await Promise.all(
                keys.map((key) =>
                    makeRequest("get", webEndPoint + key)
                )
            );
            responses.forEach((res, index) => {
                if (res) {
                    apis[keys[index]](res.data);
                }
            });
        } catch (err) {
            console.error("Error fetching master data:", err);
        } finally {
            setLoading(false);
        }
    };
    const openAdd = () => {
        setEditState(null);
        setOpen(true);
    };
    const openDelete = (id) => {
        setDeleteId(id);
        setDeleteOpen(true);
    }
    const handleDeleteConfirm = async () => {
        try {
            setLoading(true);
            let url = webEndPoint + "product/" + deleteId;
            await makeRequest("delete", url);
            setMessage("Product deleted successfully");
            setSnackbar(true);
            fetchProductdata();
        } catch (err) {
            console.error(err);
            setMessage("Failed to delete Product");
            setSnackbar(true);
        } finally {
            setLoading(false);
            setDeleteOpen(false);
        }
    };
    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };
    const openEdit = async (data) => {
        setEditState(data);
        setProductCode(data?.product_code);
        setProductName(data?.product_name);
        setProductDescription(data?.product_description);
        setSingleCheckout(data?.product_default_size_id);
        setSizeGuidePreview(data?.product_guide_image);
        setProductPreview(data?.product_main_image);
        setProductMainCategory(data?.main_category_id);
        setProductSubCategory(data?.sub_category_id);
        setProductBrand(data?.brand_id);
        setProductTax(data?.tax_id);
        setOpen(true);
        try {
            let url = webEndPoint + "subcategories/bycategory/" + data?.main_category_id;
            const response = await makeRequest("get", url);
            if (response) {
                setLoading(false);
                setsubCategoryData(response?.data);
            }
        } catch (err) {
            if (err?.message) {
                setMessage(err.message);
            } else {
                setMessage("Something went wrong");
            }
        } finally {
            setLoading(false);
        }
    };
    const handleSave = async () => {
        if (!productMainCategory) {
            setMessage("Please Select Main Category");
            setSnackbar(true);
            return;
        }
        if (!productSubCategory) {
            setMessage("Please Select Sub Category");
            setSnackbar(true);
            return;
        }
        if (!productBrand) {
            setMessage("Please Select Brand");
            setSnackbar(true);
            return;
        }
        if (!productTax) {
            setMessage("Please Select Tax");
            setSnackbar(true);
            return;
        }
        if (!productCode?.trim()) {
            setMessage("Please Enter Product Code");
            setSnackbar(true);
            return;
        }
        if (!productName?.trim()) {
            setMessage("Please Enter Product Name");
            setSnackbar(true);
            return;
        }
        if (!productDescription?.trim()) {
            setMessage("Please Enter Product Description");
            setSnackbar(true);
            return;
        }
        if (!productPreview) {
            setMessage("Please Upload Product Image");
            setSnackbar(true);
            return;
        }
        if (!sizeGuidePreview) {
            setMessage("Please Upload Size Guide Image");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const productEditData = {
                    main_category_id: productMainCategory,
                    sub_category_id: productSubCategory,
                    brand_id: productBrand,
                    tax_id: productTax,
                    product_code: productCode,
                    product_name: productName,
                    product_description: productDescription,
                    product_main_image: productImage ? productImage : productPreview,
                    product_guide_image: sizeGuideImage ? sizeGuideImage : sizeGuidePreview,
                    product_mrp_price: 0,
                    product_sales_price: 0,
                    product_default_size_id: singleCheckout,
                    product_color_status: colorStatus === "yes" ? 1 : 0,
                    product_size_status: sizeStatus === "yes" ? 1 : 0,
                    product_age_status: ageStatus === "yes" ? 1 : 0,
                };
                try {
                    setLoading(true);
                    try {
                        const productUrl = webEndPoint + "product/" + editState?.rfId;
                        const productRes = await makeRequest("put", productUrl, productEditData);
                        if (productRes) {
                            setProducRfId(editState?.rfId);
                            setMessage("Product Updated Successfully");
                        }
                    } catch (err) {
                        if (err?.message) {
                            setMessage(err.message);
                        } else {
                            setMessage("Something went wrong");
                        }
                    } finally {
                        setLoading(false);
                    }
                } catch (err) {
                    console.error(err);
                    if (err?.response?.data?.message) {
                        setMessage(err.response.data.message);
                    } else if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            } else {
                setLoading(true);
                const productAddData = {
                    main_category_id: productMainCategory,
                    sub_category_id: productSubCategory,
                    brand_id: productBrand,
                    tax_id: productTax,
                    product_code: productCode,
                    product_name: productName,
                    product_description: productDescription,
                    product_main_image: productImage ? productImage : productPreview,
                    product_guide_image: sizeGuideImage ? sizeGuideImage : sizeGuidePreview,
                    product_mrp_price: 0,
                    product_sales_price: 0,
                    product_default_size_id: singleCheckout,
                    product_color_status: colorStatus === "yes" ? 1 : 0,
                    product_size_status: sizeStatus === "yes" ? 1 : 0,
                    product_age_status: ageStatus === "yes" ? 1 : 0,
                };
                try {
                    setLoading(true);
                    const productRes = await makeRequest("post", webEndPoint + "product", productAddData);
                    if (!productRes) {
                        throw new Error("Product creation failed");
                    }
                    setProducRfId(productRes?.data?.rfId);
                    setMessage("Product Added Successfully");
                } catch (err) {
                    console.error(err);
                    if (err?.response?.data?.message) {
                        setMessage(err.response.data.message);
                    } else if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            }
            setSnackbar(true);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
            const formData = new FormData();
            formData.append('file', file);
            try {
                setLoading(true);
                const response = await fetch(webEndPoint + 'upload', {
                    method: 'POST',
                    body: formData,
                });
                const data = await response.text();
                setSizeGuidePreview(data);
                setLoading(false);
            } catch (error) {
                setMessage('Error during file upload:');
                setSnackbar(true);
                setLoading(false);
            }
        }
    };
    const handleProductImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
            const formData = new FormData();
            formData.append('file', file);
            try {
                setLoading(true);
                const response = await fetch(webEndPoint + 'upload', {
                    method: 'POST',
                    body: formData,
                });
                const data = await response.text();
                setProductPreview(data);
                setLoading(false);
            } catch (error) {
                setMessage('Error during file upload:');
                setSnackbar(true);
                setLoading(false);
            }
        }
    };
    const handleColorImageChange = async (e) => {
        setLoading(true);
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
            const formData = new FormData();
            formData.append('file', file);
            try {
                const response = await fetch(webEndPoint + 'upload', {
                    method: 'POST',
                    body: formData,
                });
                const data = await response.text();
                setSelectedColorImage(data);
                setLoading(false);
            } catch (error) {
                setMessage('Error during file upload:');
                setSnackbar(true);
                setLoading(false);
            }
        }
    };

    const handleViewAttributes = async (product) => {
        setTab(0);
        setSelectedProduct(product);
        setLoading(true);
        try {
            let url = webEndPoint + "productAttributes/product/" + product?.rfId;
            const response = await makeRequest("get", url);
            if (response) {
                setSelectAgeData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setOpenAttrModal(true);
    };
    const handleChange = (event) => {
        const value = event.target.value;
        setSingleCheckout(value);
    };
    const handleCloseAttrModal = () => {
        setOpenAttrModal(false);
        setSelectedProduct(null);
    };
    const handlePreview = (img) => {
        setPreviewImage(img);
        setPreviewOpen(true);
    };
    const handleClosePreview = () => {
        setPreviewOpen(false);
        setPreviewImage(null);
    };
    const filteredData = dataSource?.filter((d) =>
        d?.product_name?.toLowerCase().includes(search?.toLowerCase()) || d?.product_code?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "Main Category", "Sub Category", "Product Code", "Product Name", "Product Image", "View Attributes", "Action"];
    const rows = filteredData?.map((p, i) => [i + 1, p.maincategory_name, p.subcategory_name, p.product_code, p.product_name,
    <Box sx={{ display: "flex", gap: 1 }}>
        <img key={i} src={p.product_main_image} alt="" width="40" onClick={() => handlePreview(p.product_main_image || noImage)} style={{ borderRadius: 6, cursor: "pointer", transition: "0.3s" }} onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"} onMouseOut={e => e.currentTarget.style.transform = "scale(1)"} />
    </Box>,
    <Button variant="outlined" size="small" onClick={() => handleViewAttributes(p)}>View</Button>,
    <Box>
        <Tooltip title="Edit"><IconButton onClick={() => openEdit(p)} color="primary"><EditIcon /></IconButton></Tooltip>
        <Tooltip title="Delete"><IconButton onClick={() => openDelete(p?.rfId)} color="error"><DeleteIcon /></IconButton></Tooltip>
    </Box>
    ]);
    const handleEdit = (item, type) => {
        setEditAttributesData(item);
        setEditType(type);
        if (type === "Color") {
            setSelectedColorId(item.color_id);
            setSelectedColorImage(item?.color_image_url);
        }
        if (type === "Size") {
            setSelectedSizeId(item.size_id);
            setMrp(item?.sizemrp);
            setPrice(item?.sizesalesprice);
            setSizeRetailQty(item?.retail_quantity);
        }
        if (type === "Age") {
            setSelectedAgeId(item.age_id);
            setAgeMrp(item?.agemrp);
            setAgePrice(item?.agesalesprice);
            setAgeRetailQty(item?.retail_quantity);
        }
        setEditOpen(true);
    };
    const openDeleteDialog = (product, type) => {
        setDeleteData({ product, type });
        setConfirmOpen(true);
    };
    const confirmDelete = async () => {
        const { product, type } = deleteData;
        const endpoint = "productAttributes";
        setLoading(true);
        try {
            const url = `${webEndPoint}${endpoint}/${product?.rfId}`;
            const response = await makeRequest("delete", url);
            if (response) {
                setMessage('Product Attribute Removed Successfully');
                setSnackbar(true);
                handleViewAttributes(selectedProduct);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
            setConfirmOpen(false);
        }
    };
    const handleUpdate = async () => {
        setLoading(true);
        try {
            let attributeData = {
                product_id: editAttributesData?.product_id || null,
                color_id: editType === "Color" ? selectedColorId || null : editAttributesData?.color_id || null,
                color_image_url: editType === "Color" ? selectedColorImage || null : editAttributesData?.color_image_url || null,
                size_id: editType === "Size" ? selectedSizeId || null : editAttributesData?.size_id || null,
                sizemrp: editType === "Size" ? mrp || null : editAttributesData?.sizemrp || null,
                sizesalesprice: editType === "Size" ? price || null : editAttributesData?.sizesalesprice || null,
                age_id: editType === "Age" ? selectedAgeId || null : editAttributesData?.age_id || null,
                agemrp: editType === "Age" ? ageMrp || null : editAttributesData?.agemrp || null,
                agesalesprice: editType === "Age" ? agePrice || null : editAttributesData?.agesalesprice || null,
                retail_quantity: editType === "Size" ? sizeretailsQty || null : editType === "Age" ? ageretailsQty || null : editAttributesData?.retail_quantity || null,
                wholesale_quantity: null,
                size_image_url: null,
                age_image_url: null
            };
            let url = webEndPoint + "productAttributes/" + editAttributesData?.rfId;
            const response = await makeRequest("put", url, attributeData);
            if (response) {
                setMessage("Updated Successfully");
                setSnackbar(true);
                setEditOpen(false);
                try {
                    let url = webEndPoint + "productAttributes/product/" + selectedProduct?.rfId;
                    const response = await makeRequest("get", url);
                    if (response) {
                        setSelectAgeData(response?.data);
                        setLoading(false);
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }
        } catch (err) {
            console.log(err);
            setMessage(err?.response?.data?.message || err?.message || "Something went wrong");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    const handleSingleImageUpload = async (file) => {
        if (!file) return;
        const preview = URL.createObjectURL(file);
        setEditData(prev => ({
            ...prev,
            preview,
            file
        }));
        const formData = new FormData();
        formData.append("file", file);
        try {
            setLoading(true);
            const response = await fetch(webEndPoint + "upload", {
                method: "POST",
                body: formData
            });
            const data = await response.text();
            setEditData(prev => ({
                ...prev,
                image_url: data
            }));
        } catch (error) {
            console.error(error);
            setMessage("Error during file upload");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setColorStatus("no");
        setSelectedColorId("");
        setSelectedColorImage(null);
        setSizeStatus("no");
        setSizeRows([
            { sizeId: "", mrp: "", price: "", qty: "" }
        ]);
        setAgeStatus("no");
        setAgeRows([
            { ageId: "", mrp: "", price: "", qty: "" }
        ]);
    };
    const resetProductForm = () => {
        setProductMainCategory("");
        setProductSubCategory("");
        setProductBrand("");
        setProductTax("");
        setProductCode("");
        setProductName("");
        setProductDescription("");
        setSizeGuidePreview(null);
        setProductPreview(null);
        setSingleCheckout("no");
        fetchProductdata();
    };
    // const handleAttributeSave = async () => {
    //     if (!productRfId) {
    //         setMessage("Please Save Product First");
    //         setSnackbar(true);
    //         return;
    //     }
    //     if (colorStatus === "yes") {
    //         if (!selectedColorId) {
    //             setMessage("Please Select Color");
    //             setSnackbar(true);
    //             return;
    //         }
    //         if (!selectedColorImage) {
    //             setMessage("Please Upload Color Image");
    //             setSnackbar(true);
    //             return;
    //         }
    //     }
    //     if (ageStatus === "yes") {
    //         if (!ageRows || ageRows.length === 0) {
    //             setMessage("Please Add At Least One Age");
    //             setSnackbar(true);
    //             return;
    //         }
    //         for (let i = 0; i < ageRows.length; i++) {
    //             const row = ageRows[i];
    //             if (!row.ageId) {
    //                 setMessage(`Please Select Age in Row ${i + 1}`);
    //                 setSnackbar(true);
    //                 return;
    //             }
    //             if (!row.mrp) {
    //                 setMessage(`Please Enter MRP in Row ${i + 1}`);
    //                 setSnackbar(true);
    //                 return;
    //             }
    //             if (!row.price) {
    //                 setMessage(`Please Enter Price in Row ${i + 1}`);
    //                 setSnackbar(true);
    //                 return;
    //             }
    //             if (!row.qty) {
    //                 setMessage(`Please Enter Stock Qty in Row ${i + 1}`);
    //                 setSnackbar(true);
    //                 return;
    //             }
    //         }
    //     }
    //     if (sizeStatus === "yes") {
    //         if (!sizeRows || sizeRows.length === 0) {
    //             setMessage("Please Add At Least One Size");
    //             setSnackbar(true);
    //             return;
    //         }
    //         for (let i = 0; i < sizeRows.length; i++) {
    //             const row = sizeRows[i];
    //             if (!row.sizeId) {
    //                 setMessage(`Please Select Size in Row ${i + 1}`);
    //                 setSnackbar(true);
    //                 return;
    //             }
    //             if (!row.mrp) {
    //                 setMessage(`Please Enter MRP in Row ${i + 1}`);
    //                 setSnackbar(true);
    //                 return;
    //             }
    //             if (!row.price) {
    //                 setMessage(`Please Enter Price in Row ${i + 1}`);
    //                 setSnackbar(true);
    //                 return;
    //             }
    //             if (!row.qty) {
    //                 setMessage(`Please Enter Stock Qty in Row ${i + 1}`);
    //                 setSnackbar(true);
    //                 return;
    //             }
    //         }
    //     }
    //     if (ageStatus !== "yes" && sizeStatus !== "yes") {
    //         setMessage("Please Enable Age or Size");
    //         setSnackbar(true);
    //         return;
    //     }
    //     setLoading(true);
    //     try {
    //         let url = webEndPoint + "productAttributes";
    //         if (sizeRows.length > 0 && sizeStatus === "yes") {
    //             for (const row of sizeRows) {
    //                 const payload = {
    //                     product_id: productRfId,
    //                     color_id: selectedColorId,
    //                     size_id: row.sizeId,
    //                     age_id: null,
    //                     retail_quantity: row.qty,
    //                     wholesale_quantity: null,
    //                     color_image_url: selectedColorImage,
    //                     size_image_url: "",
    //                     age_image_url: "",
    //                     sizemrp: row.mrp,
    //                     sizesalesprice: row.price,
    //                     agemrp: null,
    //                     agesalesprice: null
    //                 };
    //                 await makeRequest("post", url, payload);
    //             }
    //         }
    //         if (ageRows.length > 0 && ageStatus === "yes") {
    //             for (const row of ageRows) {
    //                 const payload = {
    //                     product_id: productRfId,
    //                     color_id: selectedColorId,
    //                     size_id: null,
    //                     age_id: row.ageId,
    //                     retail_quantity: row.qty,
    //                     wholesale_quantity: null,
    //                     color_image_url: selectedColorImage,
    //                     size_image_url: "",
    //                     age_image_url: "",
    //                     sizemrp: null,
    //                     sizesalesprice: null,
    //                     agemrp: row.mrp,
    //                     agesalesprice: row.price
    //                 };
    //                 await makeRequest("post", url, payload);
    //             }
    //         }
    //         setMessage("Product Attributes Added Successfully");
    //         setSnackbar(true);
    //         // resetForm();
    //     } catch (err) {
    //         setMessage(err?.message || "Something went wrong");
    //         setSnackbar(true);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleAttributeSave = async () => {
        if (!productRfId) {
            setMessage("Please Save Product First");
            setSnackbar(true);
            return;
        }
        if (colorStatus === "yes") {
            if (!selectedColorId) {
                setMessage("Please Select Color");
                setSnackbar(true);
                return;
            }
            if (!selectedColorImage) {
                setMessage("Please Upload Color Image");
                setSnackbar(true);
                return;
            }
        }
        if (ageStatus === "yes") {
            if (!ageRows || ageRows.length === 0) {
                setMessage("Please Add At Least One Age");
                setSnackbar(true);
                return;
            }
            for (let i = 0; i < ageRows.length; i++) {
                const row = ageRows[i];
                if (!row.ageId) {
                    setMessage(`Please Select Age in Row ${i + 1}`);
                    setSnackbar(true);
                    return;
                }
                if (!row.mrp) {
                    setMessage(`Please Enter MRP in Row ${i + 1}`);
                    setSnackbar(true);
                    return;
                }
                if (!row.price) {
                    setMessage(`Please Enter Price in Row ${i + 1}`);
                    setSnackbar(true);
                    return;
                }
                if (!row.qty) {
                    setMessage(`Please Enter Stock Qty in Row ${i + 1}`);
                    setSnackbar(true);
                    return;
                }
            }
        }

        if (sizeStatus === "yes") {
            if (!sizeRows || sizeRows.length === 0) {
                setMessage("Please Add At Least One Size");
                setSnackbar(true);
                return;
            }
            for (let i = 0; i < sizeRows.length; i++) {
                const row = sizeRows[i];
                if (!row.sizeId) {
                    setMessage(`Please Select Size in Row ${i + 1}`);
                    setSnackbar(true);
                    return;
                }
                if (!row.mrp) {
                    setMessage(`Please Enter MRP in Row ${i + 1}`);
                    setSnackbar(true);
                    return;
                }
                if (!row.price) {
                    setMessage(`Please Enter Price in Row ${i + 1}`);
                    setSnackbar(true);
                    return;
                }
                if (!row.qty) {
                    setMessage(`Please Enter Stock Qty in Row ${i + 1}`);
                    setSnackbar(true);
                    return;
                }
            }
        }
        if (ageStatus !== "yes" && sizeStatus !== "yes") {
            setMessage("Please Enable Age or Size");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            const url = webEndPoint + "productAttributes";
            const existingResponse = await makeRequest("get", `${webEndPoint}productAttributes/product/${productRfId}`);
            const existingAttributes = existingResponse?.data || [];
            const duplicateList = [];
            let addedCount = 0;
            if (sizeStatus === "yes") {
                for (const row of sizeRows) {
                    const exists = existingAttributes.some(
                        (item) =>
                            Number(item.color_id) === Number(selectedColorId) &&
                            Number(item.size_id) === Number(row.sizeId)
                    );
                    if (exists) {
                        const duplicate = existingAttributes.find(
                            item =>
                                Number(item.color_id) === Number(selectedColorId) &&
                                Number(item.size_id) === Number(row.sizeId)
                        );
                        duplicateList.push(
                            `${duplicate?.color_name} - ${duplicate?.size_name}`
                        );
                        continue;
                    }
                    const payload = {
                        product_id: productRfId,
                        color_id: selectedColorId,
                        size_id: row.sizeId,
                        age_id: null,
                        retail_quantity: row.qty,
                        wholesale_quantity: null,
                        color_image_url: selectedColorImage,
                        size_image_url: "",
                        age_image_url: "",
                        sizemrp: row.mrp,
                        sizesalesprice: row.price,
                        agemrp: null,
                        agesalesprice: null
                    };
                    await makeRequest("post", url, payload);
                    addedCount++;
                    existingAttributes.push({
                        color_id: selectedColorId,
                        size_id: row.sizeId,
                        age_id: null
                    });
                }
            }
            if (ageStatus === "yes") {
                for (const row of ageRows) {
                    const exists = existingAttributes.some(
                        (item) =>
                            Number(item.color_id) === Number(selectedColorId) &&
                            Number(item.age_id) === Number(row.ageId)
                    );
                    if (exists) {
                        const duplicate = existingAttributes.find(
                            item =>
                                Number(item.color_id) === Number(selectedColorId) &&
                                Number(item.age_id) === Number(row.ageId)
                        );
                        duplicateList.push(
                            `${duplicate?.color_name} - ${duplicate?.age_name}`
                        );
                        continue;
                    }
                    const payload = {
                        product_id: productRfId,
                        color_id: selectedColorId,
                        size_id: null,
                        age_id: row.ageId,
                        retail_quantity: row.qty,
                        wholesale_quantity: null,
                        color_image_url: selectedColorImage,
                        size_image_url: "",
                        age_image_url: "",
                        sizemrp: null,
                        sizesalesprice: null,
                        agemrp: row.mrp,
                        agesalesprice: row.price
                    };
                    await makeRequest("post", url, payload);
                    addedCount++;
                    existingAttributes.push({
                        color_id: selectedColorId,
                        size_id: null,
                        age_id: row.ageId
                    });
                }
            }
            if (addedCount > 0 && duplicateList.length === 0) {
                setMessage("Product Attributes Added Successfully");
            } else if (addedCount > 0 && duplicateList.length > 0) {
                setMessage(
                    `${addedCount} Attribute(s) Added Successfully.\n\nDuplicate Attribute(s):\n${duplicateList.join(
                        "\n"
                    )}`
                );
            } else {
                setMessage(
                    `All Selected Attributes Already Exist.\n\n${duplicateList.join(
                        "\n"
                    )}`
                );
            }
            setSnackbar(true);
        } catch (err) {
            setMessage(err?.message || "Something went wrong");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };

    const handleRowChange = (index, field, value) => {
        const updatedRows = [...sizeRows];
        updatedRows[index][field] = value;
        setSizeRows(updatedRows);
    };
    const addRow = () => {
        setSizeRows([
            ...sizeRows,
            { sizeId: "", mrp: "", price: "", qty: "" }
        ]);
    };
    const removeRow = (index) => {
        const updatedRows = sizeRows.filter((_, i) => i !== index);
        setSizeRows(updatedRows);
    };
    const handleAgeChange = (index, field, value) => {
        const updated = [...ageRows];
        updated[index][field] = value;
        setAgeRows(updated);
    };
    const addAgeRow = () => {
        setAgeRows([...ageRows, { ageId: "", mrp: "", price: "", qty: "" }]);
    };
    const removeAgeRow = (index) => {
        const updated = ageRows.filter((_, i) => i !== index);
        setAgeRows(updated);
    };
    const handleMainCategoryChange = async (e) => {
        const value = e.target.value;
        setProductMainCategory(value);
        setProductSubCategory("");
        try {
            let url = webEndPoint + "subcategories/bycategory/" + e.target.value;
            const response = await makeRequest("get", url);
            if (response) {
                setLoading(false);
                setsubCategoryData(response?.data);
            }
        } catch (err) {
            if (err?.message) {
                setMessage(err.message);
            } else {
                setMessage("Something went wrong");
            }
        } finally {
            setLoading(false);
        }
    };

    const checkProductCode = async (value) => {
        const code = value?.trim();
        if (!code) {
            setProductCodeExists(false);
            return;
        }
        setCheckingProductCode(true);
        try {
            const excludeId = editState?.rfId ? `&exclude_id=${editState.rfId}` : "";
            const url = `${webEndPoint}product/check-product-code?product_code=${encodeURIComponent(code)}${excludeId}`;
            const response = await makeRequest("get", url);
            if (response?.exists) {
                setProductCodeExists(true);
            } else {
                setProductCodeExists(false);
            }
        } catch (error) {
            console.error("Product code check failed:", error);
            setProductCodeExists(false);
        } finally {
            setCheckingProductCode(false);
        }
    };

    return (
        <>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Box sx={{ position: "relative" }}>
                <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Products</Typography>
                <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                    <TextField label="Search Product Name / Code" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
                    <Button variant="contained" startIcon={<AddIcon />} onClick={() => { resetForm(); openAdd(); }}>Add Product</Button>
                </Box>
                <DataTable columns={columns} rows={rows} loading={false} />
                <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
                    <Box component="div" sx={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, overflowY: "auto", p: 2 }}>
                        <Box sx={{ bgcolor: "#fff", p: 4, borderRadius: 2, width: "80%", maxHeight: "80vh", overflowY: "auto", zIndex: 1000 }}>
                            <Typography variant="h6" sx={{ mb: 2 }}>{editState !== null ? "Edit Product" : "Add Product"}</Typography>
                            <TextField select label="Select Main Category" value={productMainCategory} onChange={handleMainCategoryChange} sx={{ mt: 2 }} fullWidth>
                                {mainCategoryData.map((state) => (
                                    <MenuItem key={state.rfId} value={state.rfId}>{state.maincategory_name}</MenuItem>
                                ))}
                            </TextField>
                            <TextField select label="Select Sub Category" value={productSubCategory} onChange={(e) => setProductSubCategory(e.target.value)} sx={{ mt: 2 }} fullWidth>
                                {subCategoryData.map((state) => (
                                    <MenuItem key={state.subcategory_id} value={state.subcategory_id}>{state.subcategory_name}</MenuItem>
                                ))}
                            </TextField>
                            <TextField select label="Select Brand" value={productBrand} onChange={(e) => setProductBrand(e.target.value)} sx={{ mt: 2 }} fullWidth>
                                {brandCategoryData.map((state) => (
                                    <MenuItem key={state.rfId} value={state.rfId}>{state.brand_name}</MenuItem>
                                ))}
                            </TextField>
                            <TextField select label="Select Tax Value" value={productTax} onChange={(e) => setProductTax(e.target.value)} sx={{ mt: 2 }} fullWidth>
                                {taxData.map((state) => (
                                    <MenuItem key={state.rfId} value={state.rfId}>{state.tax_name}</MenuItem>
                                ))}
                            </TextField>
                            {/* <TextField label="Product Code" value={productCode} onChange={(e) => setProductCode(e.target.value)} sx={{ mt: 2 }} fullWidth /> */}
                            <TextField
                                label="Product Code"
                                value={productCode || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setProductCode(value); setProductCodeExists(false); checkProductCode(value);
                                }} sx={{ mt: 2 }} fullWidth
                                error={productCodeExists}
                                helperText={checkingProductCode ? "Checking product code..." : productCodeExists ? "Product code already exists" : productCode?.trim() ? "Product code available" : ""} />
                            <TextField label="Product Name" value={productName} onChange={(e) => setProductName(e.target.value)} sx={{ mt: 2 }} fullWidth />
                            <TextField label="Product Description" value={productDescription} onChange={(e) => setProductDescription(e.target.value)} sx={{ mt: 2 }} fullWidth multiline rows={6} />
                            <Box sx={{ mt: 2 }}>
                                <Typography variant="subtitle1">Product Image</Typography>
                                <Button variant="outlined" component="label" sx={{ mt: 2 }}> Upload Product Image <input hidden type="file" accept="image/*" onChange={(e) => handleProductImageChange(e)} /></Button>
                                {productPreview && (
                                    <img src={productPreview} alt="Product Preview" style={{ width: 120, height: 120, objectFit: "cover", marginTop: 10, borderRadius: 8, border: "1px solid #ddd", cursor: "pointer" }}
                                        onClick={() => handlePreview(productPreview || noImage)} onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"} onMouseOut={e => e.currentTarget.style.transform = "scale(1)"} />
                                )}
                            </Box>
                            <Box sx={{ mt: 2 }}>
                                <Typography variant="subtitle1">Size Guide Image</Typography>
                                <Button variant="outlined" component="label" sx={{ mt: 2 }}> Upload Product Size Guide Image <input hidden type="file" accept="image/*" onChange={(e) => handleImageChange(e)} /></Button>
                                {sizeGuidePreview && (
                                    <img src={sizeGuidePreview} alt="Size Guide Preview" style={{ width: 120, height: 120, objectFit: "cover", marginTop: 10, borderRadius: 8, border: "1px solid #ddd", cursor: "pointer" }}
                                        onClick={() => handlePreview(sizeGuidePreview || noImage)} onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"} onMouseOut={e => e.currentTarget.style.transform = "scale(1)"} />
                                )}
                            </Box>
                            <Box sx={{ mt: 2 }}>
                                <FormLabel>Single Product Checkout</FormLabel>
                                <RadioGroup row value={singleCheckout} onChange={handleChange}>
                                    <FormControlLabel value={1} control={<Radio />} label="Yes" />
                                    <FormControlLabel value={0} control={<Radio />} label="No" />
                                </RadioGroup>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
                                <Button variant="contained" onClick={handleSave}>Save Products</Button>
                                <Button variant="contained" disabled={!productRfId || productRfId <= 0} sx={{ backgroundColor: "green", color: "white", "&:hover": { backgroundColor: "darkred" } }} onClick={() => setOpenModal(true)}>Add Attributes</Button>
                            </Box>

                            {openModal &&
                                <Box>
                                    <Box sx={{ mt: 2 }}>
                                        <FormLabel>Enable Color</FormLabel>
                                        <RadioGroup row value={colorStatus} onChange={(e) => setColorStatus(e.target.value)}>
                                            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                            <FormControlLabel value="no" control={<Radio />} label="No" />
                                        </RadioGroup>
                                    </Box>
                                    {colorStatus === 'yes' && (
                                        <>
                                            <FormControl fullWidth sx={{ mt: 2 }}>
                                                <TextField select label="Select Color" value={selectedColorId || ""} onChange={(e) => setSelectedColorId(Number(e.target.value))} fullWidth>
                                                    {colorData.map((c) => (
                                                        <MenuItem key={c.rfId} value={c.rfId}>
                                                            {c.color_name}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </FormControl>
                                            <Button component="label" variant="outlined" sx={{ mt: 2 }}>Upload Image
                                                <input hidden type="file" onChange={handleColorImageChange} />
                                            </Button>
                                            {selectedColorImage && (
                                                <img src={selectedColorImage} alt="Size Guide Preview" style={{ width: 120, height: 120, objectFit: "cover", marginTop: 10, borderRadius: 8, border: "1px solid #ddd", cursor: "pointer" }} onClick={() => handlePreview(selectedColorImage || noImage)} onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"} onMouseOut={e => e.currentTarget.style.transform = "scale(1)"} />
                                            )}
                                        </>
                                    )}
                                    <Box sx={{ mt: 2 }}>
                                        <FormLabel>Enable Size</FormLabel>
                                        <RadioGroup row value={sizeStatus} onChange={(e) => setSizeStatus(e.target.value)}>
                                            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                            <FormControlLabel value="no" control={<Radio />} label="No" />
                                        </RadioGroup>
                                    </Box>
                                    {sizeStatus === "yes" && (
                                        <>
                                            {sizeRows.map((row, index) => (
                                                <Box key={index} sx={{ mt: 2, p: 2, border: "1px solid #ddd", borderRadius: 2 }}>
                                                    <FormControl fullWidth sx={{ mb: 2 }}>
                                                        <TextField select label="Select Size" value={row.sizeId} onChange={(e) => handleRowChange(index, "sizeId", Number(e.target.value))} fullWidth>
                                                            {sizeCategoryData.map((s) => (
                                                                <MenuItem key={s.rfId} value={s.rfId}>
                                                                    {s.size_name}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                    </FormControl>
                                                    <TextField label="MRP" value={row.mrp}
                                                        onChange={(e) => { const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { handleRowChange(index, "mrp", value); } }}
                                                        inputProps={{ inputMode: "decimal", }} fullWidth sx={{ mb: 2 }} />
                                                    <TextField label="Price" value={row.price}
                                                        onChange={(e) => { const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { handleRowChange(index, "price", value); } }}
                                                        inputProps={{ inputMode: "decimal", }} fullWidth sx={{ mb: 2 }} />
                                                    <TextField label="Stock Qty" value={row.qty}
                                                        onChange={(e) => { const value = e.target.value; if (/^\d*$/.test(value)) { handleRowChange(index, "qty", value); } }}
                                                        inputProps={{ inputMode: "numeric", }} fullWidth sx={{ mb: 2 }} />
                                                    {sizeRows.length > 1 && (
                                                        <Button color="error" onClick={() => removeRow(index)}>
                                                            Remove
                                                        </Button>
                                                    )}
                                                </Box>
                                            ))}
                                            <Button variant="contained" sx={{ mt: 2 }} onClick={addRow}>+ Add More</Button>
                                        </>
                                    )}
                                    <Box sx={{ mt: 2 }}>
                                        <FormLabel>Enable Age</FormLabel>
                                        <RadioGroup row value={ageStatus} onChange={(e) => setAgeStatus(e.target.value)}>
                                            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                            <FormControlLabel value="no" control={<Radio />} label="No" />
                                        </RadioGroup>
                                    </Box>
                                    {ageStatus === "yes" && (
                                        <>
                                            {ageRows.map((row, index) => (
                                                <Box key={index} sx={{ mt: 2, p: 2, border: "1px solid #ddd", borderRadius: 2 }}>
                                                    <FormControl fullWidth sx={{ mb: 2 }}>
                                                        <TextField select label="Select Age" value={row.ageId} onChange={(e) => handleAgeChange(index, "ageId", Number(e.target.value))} fullWidth>
                                                            {ageCategoryData.map((a) => (
                                                                <MenuItem key={a.rfId} value={a.rfId}>
                                                                    {a.age_name}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                    </FormControl>
                                                    <TextField label="MRP" value={row.mrp}
                                                        onChange={(e) => { const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { handleAgeChange(index, "mrp", value); } }}
                                                        inputProps={{ inputMode: "decimal", }} fullWidth sx={{ mb: 2 }} />
                                                    <TextField label="Price" value={row.price}
                                                        onChange={(e) => { const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { handleAgeChange(index, "price", value); } }}
                                                        inputProps={{ inputMode: "decimal", }} fullWidth sx={{ mb: 2 }} />
                                                    <TextField label="Stock Qty" value={row.qty}
                                                        onChange={(e) => { const value = e.target.value; if (/^\d*$/.test(value)) { handleAgeChange(index, "qty", value); } }}
                                                        inputProps={{ inputMode: "numeric", }} fullWidth sx={{ mb: 2 }} />
                                                    {ageRows.length > 1 && (
                                                        <Button color="error" onClick={() => removeAgeRow(index)}>Remove</Button>
                                                    )}
                                                </Box>
                                            ))}
                                            <Button variant="contained" sx={{ mt: 2 }} onClick={addAgeRow}>+ Add More</Button>
                                        </>
                                    )}
                                </Box>
                            }
                            <Box sx={{ display: "flex", justifyContent: "flex-start", gap: 2, mt: 2 }}>
                                <Button variant="contained" onClick={handleAttributeSave}>Save Attributes</Button>
                                <Button color="error" variant="contained" onClick={() => { resetProductForm(); setOpen(false) }}>Close</Button>
                            </Box>
                        </Box>
                    </Box>
                </Dialog>
                <Dialog open={openAttrModal} onClose={handleCloseAttrModal} maxWidth="md" fullWidth>
                    <DialogTitle>Product Attributes
                        <IconButton onClick={handleCloseAttrModal} sx={{ position: "absolute", right: 10, top: 10 }}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                        {selectedProduct ? (
                            <Box>
                                <Typography variant="subtitle1" gutterBottom>Product Name : {selectedProduct.product_name}</Typography>
                                <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)}>
                                    <Tab label="Sizes" />
                                    <Tab label="Colors" />
                                    <Tab label="Ages" />
                                </Tabs>
                                {tab === 0 && (
                                    <TableContainer sx={{ mt: 2 }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>Color</TableCell>
                                                    <TableCell>Size</TableCell>
                                                    <TableCell>MRP</TableCell>
                                                    <TableCell>Price</TableCell>
                                                    <TableCell>Stock</TableCell>
                                                    <TableCell>Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {selectAgeData?.filter(item => item.size_name)
                                                    .map((item, i) => (
                                                        <TableRow key={item.rfId}>
                                                            <TableCell>{i + 1}</TableCell>
                                                            <TableCell>{item.color_name}</TableCell>
                                                            <TableCell>{item.size_name}</TableCell>
                                                            <TableCell>{item.sizemrp}</TableCell>
                                                            <TableCell>{item.sizesalesprice}</TableCell>
                                                            <TableCell>{item.retail_quantity}</TableCell>
                                                            <TableCell>
                                                                <Tooltip title="Edit">
                                                                    <IconButton color="primary" onClick={() => handleEdit(item, 'Size')}>
                                                                        <EditIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Delete">
                                                                    <IconButton color="error" onClick={() => openDeleteDialog(item, 'Size')}>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                                {tab === 1 && (
                                    <TableContainer sx={{ mt: 2 }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>Color</TableCell>
                                                    <TableCell>Size/Age</TableCell>
                                                    <TableCell>Image</TableCell>
                                                    <TableCell>Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {selectAgeData?.filter(item => item.color_name)
                                                    .map((item, i) => (
                                                        <TableRow key={item.rfId}>
                                                            <TableCell>{i + 1}</TableCell>
                                                            <TableCell>{item.color_name}</TableCell>
                                                            <TableCell>{item.size_name ? item.size_name : item.age_name}</TableCell>
                                                            <TableCell>
                                                                {item.color_image_url ? (
                                                                    <img src={item.color_image_url} width={40}
                                                                        onClick={() => handlePreview(item?.color_image_url || noImage)}
                                                                        style={{ objectFit: "cover", borderRadius: 5, cursor: "pointer", transition: "0.3s" }}
                                                                        onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                                                                        onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                                                    />
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                <Tooltip title="Edit">
                                                                    <IconButton color="primary" onClick={() => handleEdit(item, "Color")}>
                                                                        <EditIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Delete">
                                                                    <IconButton color="error" onClick={() => openDeleteDialog(item, "Color")}>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                                {tab === 2 && (
                                    <TableContainer sx={{ mt: 2 }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>Color</TableCell>
                                                    <TableCell>Age</TableCell>
                                                    <TableCell>MRP</TableCell>
                                                    <TableCell>Price</TableCell>
                                                    <TableCell>Stock</TableCell>
                                                    <TableCell>Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {selectAgeData?.filter(item => item.age_name)
                                                    .map((item, i) => (
                                                        <TableRow key={item.rfId}>
                                                            <TableCell>{i + 1}</TableCell>
                                                            <TableCell>{item.color_name}</TableCell>
                                                            <TableCell>{item.age_name}</TableCell>
                                                            <TableCell>{item.agemrp}</TableCell>
                                                            <TableCell>{item.agesalesprice}</TableCell>
                                                            <TableCell>{item.retail_quantity}</TableCell>
                                                            <TableCell>
                                                                <Tooltip title="Edit">
                                                                    <IconButton color="primary" onClick={() => handleEdit(item, "Age")}>
                                                                        <EditIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Delete">
                                                                    <IconButton color="error" onClick={() => openDeleteDialog(item, "Age")}>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                            </Box>
                        ) : (
                            <Typography>No Data</Typography>
                        )}
                    </DialogContent>
                </Dialog>

                <Dialog open={previewOpen} onClose={handleClosePreview} maxWidth="md">
                    <DialogTitle>
                        Image Preview
                        <IconButton onClick={handleClosePreview} sx={{ position: "absolute", right: 10, top: 10 }}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <img src={previewImage} alt="Preview" style={{ width: "100%", borderRadius: 10 }} />
                    </DialogContent>
                </Dialog>

                <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
                    <DialogTitle>Confirm Delete</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this item? This action cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setConfirmOpen(false)} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={confirmDelete} color="error" variant="contained">
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={editOpen} onClose={() => setEditOpen(false)} maxWidth="sm" fullWidth>
                    <DialogTitle>Edit {editType}</DialogTitle>
                    <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                        {editType === "Size" && (
                            <>
                                <TextField sx={{ mt: 2 }} select label="Select Size" value={selectedSizeId ?? ""} onChange={(e) => setSelectedSizeId(Number(e.target.value))} fullWidth>
                                    {sizeCategoryData.map((s) => (
                                        <MenuItem key={s.rfId} value={s.rfId}>{s.size_name}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField label="MRP" value={mrp ?? ""} onChange={(e) => {
                                    const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { setMrp(value); }
                                }} sx={{ mt: 2 }} fullWidth />
                                <TextField label="Price" value={price ?? ""} onChange={(e) => {
                                    const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { setPrice(value); }
                                }} sx={{ mt: 2 }} fullWidth />
                                <TextField label="Stock Qty" value={sizeretailsQty ?? ""} onChange={(e) => {
                                    const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { setSizeRetailQty(value); }
                                }} sx={{ mt: 2 }} fullWidth />
                            </>
                        )}
                        {editType === "Color" && (
                            <>
                                <TextField sx={{ mt: 2 }} select label="Select Color" value={selectedColorId ?? ""} onChange={(e) => setSelectedColorId(Number(e.target.value))} fullWidth>
                                    {colorData.map((c) => (
                                        <MenuItem key={c.rfId} value={c.rfId}>{c.color_name}</MenuItem>
                                    ))}
                                </TextField>
                                <Button component="label" variant="outlined" sx={{ mt: 2 }}>Upload Image
                                    <input hidden type="file" onChange={handleColorImageChange} />
                                </Button>
                                {selectedColorImage && (
                                    <img src={selectedColorImage} alt="Size Guide Preview" style={{ width: 120, height: 120, objectFit: "cover", marginTop: 10, borderRadius: 8, border: "1px solid #ddd", cursor: "pointer" }} onClick={() => handlePreview(selectedColorImage || noImage)} onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"} onMouseOut={e => e.currentTarget.style.transform = "scale(1)"} />
                                )}
                            </>
                        )}
                        {editType === "Age" && (
                            <>
                                <TextField sx={{ mt: 2 }} select label="Select Age" value={selectedAgeId ?? ""} onChange={(e) => setSelectedAgeId(Number(e.target.value))} fullWidth>
                                    {ageCategoryData.map((a) => (
                                        <MenuItem key={a.rfId} value={a.rfId}>{a.age_name}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField label="MRP" value={ageMrp ?? ""} onChange={(e) => {
                                    const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { setAgeMrp(value); }
                                }} sx={{ mt: 2 }} fullWidth />
                                <TextField label="Price" value={agePrice ?? ""} onChange={(e) => {
                                    const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { setAgePrice(value); }
                                }} sx={{ mt: 2 }} fullWidth />
                                <TextField label="Stock Qty" value={ageretailsQty ?? ""} onChange={(e) => {
                                    const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { setAgeRetailQty(value); }
                                }} sx={{ mt: 2 }} fullWidth />
                            </>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setEditOpen(false)}>Cancel</Button>
                        <Button variant="contained" onClick={handleUpdate}>
                            Update
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={deleteOpen} onClose={handleDeleteCancel}>
                    <DialogTitle>Confirm Delete</DialogTitle>
                    <DialogContent>
                        <Typography>Are you sure you want to delete this user?</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDeleteCancel}>Cancel</Button>
                        <Button onClick={handleDeleteConfirm} color="error" variant="contained">Delete</Button>
                    </DialogActions>
                </Dialog>
            </Box >
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </>
    );
}